import { Component, HostListener, OnInit } from "@angular/core";
import * as moment from "moment";
import { TogglService } from "../toggl.service";
import { TogglDayCount } from "../toggl.types";

@Component({
    selector: 'app-toggl-time-entries',
    templateUrl: './toggl-time-entries.component.html',
    styleUrls: ['./toggl-time-entries.component.scss']
})
export class TogglTimeEntriesComponent implements OnInit {
    
    year: number;
    months: CalendarMonth[] = [];

    anchorDate?: Date;
    startDate?: Date;
    endDate?: Date;

    importing: boolean = false;
    loadingMonth: boolean = false;
    cancelLoading: boolean = false;
    dayLoading:number = 0;
    monthLoading:number = 0;
    dateLoading: Date | null = null;

    constructor(private togglService: TogglService) { }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
    // If loading is in progress, prevent the unload
        if (this.loadingMonth) {
            event.preventDefault();
            event.returnValue = '';
        }

    }
    
    ngOnInit(): void {
        this.year = new Date().getFullYear();
        // generate an array of months
        // create a number array from 1 to 12
        // for (let i = 1; i <= 12; i++) {
        //     this.months.push(new CalendarMonth(i, this.year));
        // }
        this.updateYear();
    }

    updateYear() {
        this.togglService.getTimeCalendar(this.year).subscribe({
            next: (r) => {
                if (r.success) {
                    this.year = r.calendar.year;
                    this.months = [];
                    for (let i = 1; i <= 12; i++) {
                        this.months.push(new CalendarMonth(i, this.year, r.calendar.dayCounts));
                    }
                    this.anchorDate = null;
                    this.startDate = null;
                    this.endDate = null;
                }
            }
        });
    }

    dayClick(day: CalendarDay) {
        if (day.exists) {
            // if the day is within the range, clear the range
            if (this.startDate && this.endDate && day.date && day.date >= this.startDate && day.date <= this.endDate) {
                this.startDate = this.endDate = this.anchorDate = undefined;
                return;
            }
            if (this.anchorDate) {
                if (day.date < this.anchorDate) {
                    this.startDate = day.date;
                    this.endDate = this.anchorDate;
                    this.anchorDate = undefined;
                } else if (day.date > this.anchorDate) {
                    this.startDate = this.anchorDate;
                    this.endDate = day.date;
                    this.anchorDate = undefined;
                } else {
                    this.startDate = this.endDate = this.anchorDate;
                    this.anchorDate = undefined;
                }
            } else {
                this.startDate = this.endDate = this.anchorDate = day.date;
            }
        }
    }

    cancelRange() {
        if (!this.loadingMonth) {
            this.anchorDate = null;
            this.startDate = null;
            this.endDate = null;
        }
    }

    isAnchor(day: CalendarDay) {
        return this.anchorDate && day.date && day.date.toDateString() === this.anchorDate.toDateString();
    }

    isRange(day: CalendarDay) {
        return this.startDate && this.endDate && day.date && day.date >= this.startDate && day.date <= this.endDate;
    }

    prevYear() 
    {
        this.year--;
        this.updateYear();
    }

    importTimeEntriesOld() {
        if (this.startDate && this.endDate) {
            this.importing = true;
            this.togglService.loadTimeEntries(this.startDate, this.endDate).subscribe({
                next: (r) => {
                    this.importing = false;
                    this.updateYear();
                }
            });
        }
    }

    importTimeEntries() {
        if (this.startDate && this.endDate) {
            let d = moment(this.startDate);
            let end = moment(this.endDate);
            let days: CalendarDay[] = [];
            while (d.isSameOrBefore(end)) {
                let day = new CalendarDay();
                day.date = d.toDate();
                day.exists = true;
                days.push(day);
                d.add(1, 'day');
            }
            this.loadRangeData(days);
        }
    }

    importWholeYear() {
        this.startDate = new Date(this.year, 0, 1);
        this.endDate = new Date();
        this.importTimeEntries();
    }

    updateTimeEntryRates() {
        if (this.startDate && this.endDate) {
            this.importing = true;
            this.togglService.updateTimeEntryRates(this.startDate, this.endDate).subscribe({
                next: (r) => {
                    this.importing = false;
                    this.updateYear();
                }
            });
        }
    }

    loadRangeData(days: CalendarDay[]) {
        this.loadingMonth = true;
        const loadDayData = (index: number) => {
            if (index >= days.length || this.cancelLoading) {
                this.anchorDate = null;
                this.startDate = null;
                this.endDate = null;
                this.loadingMonth = false;
                this.cancelLoading = false;
                return;
            }
            const day = days[index];
            this.startDate = day.date;
            this.dayLoading = day.date.getDate();
            this.monthLoading = day.date.getMonth();
            this.dateLoading = day.date;
            this.togglService.aggregateTimeEntries(day.date, day.date).subscribe({
                next: (r) => {
                    if (r.success) {
                        // Update the day with the loaded time entries
                        this.togglService.getTimeCalendar(this.year).subscribe({
                            next: (r) => {
                                if (r.success) {
                                    this.year = r.calendar.year;
                                    this.months = [];
                                    for (let i = 1; i <= 12; i++) {
                                        this.months.push(new CalendarMonth(i, this.year, r.calendar.dayCounts));
                                    }
                                    // Load the next day
                                    loadDayData(index + 1);
                                }
                            }
                        });
                
                    }
                }
            });
        };

        // Start loading data from the first day
        loadDayData(0);
    }

    loadMonthData(month: CalendarMonth) {
        let days: CalendarDay[] = [];
        this.startDate = this.endDate = this.anchorDate = undefined;
        month.weeks.forEach((week) => {
            week.days.forEach((day) => {
                if (!this.startDate) {
                    this.startDate = day.date;
                    this.endDate = day.date;
                }
                if (day.exists) {
                    days.push(day);
                    this.endDate = day.date; // Update endDate to the last day in the month
                }
            });
        });
        this.loadRangeData(days)
    }

    cancelLoadMonthData() {
        this.cancelLoading = true;
    }

    showDayLoading(month: CalendarMonth) {
        if (this.monthLoading === month.date.getMonth()) {
            return ` ${this.dayLoading}`;
        } else {
            return '';
        }
    }
}

class CalendarMonth {
    constructor(month: number, year: number, dayCounts: TogglDayCount[]) {
        this.date = new Date(year, month - 1, 1);
        this.month = month;
        this.year = year;
        let start = new Date(year, month - 1, 1);
        this.weeks = [];
        // generate days for the month
        let week: CalendarWeek = new CalendarWeek();
        let day: CalendarDay;
        // adjust for first day being a Monday
        let startday = (start.getDay() - 1 + 7) % 7;;
        for (let i = 0; i < startday; i++) {
            day = new CalendarDay();
            day.exists = false;
            week.days.push(day);
        }
        while (start.getMonth() === month - 1) {
            day = new CalendarDay();
            day.date = new Date(start);
            day.exists = true;
            // find an entry in dayCounts for this day
            let daycount = dayCounts.find((d) => {
                return d.day.toDateString() === start.toDateString();
            });
            if (daycount) {
                day.hasTime = true;
                day.hasValue = daycount.value > 0;
                day.hours = daycount.seconds / 3600;
                day.value = daycount.value;
            }
            else {
                day.hasTime = false;
                day.hasValue = false;
            }
            week.days.push(day);
            // if we've just done sunday, push the week
            if (start.getDay() === 0) {
                this.weeks.push(week);
                week = new CalendarWeek();
            }
            start.setDate(start.getDate() + 1);
        }
        if (week.days.length > 0) {
            this.weeks.push(week);
        }

    }
    month: number;
    year: number;
    date: Date;
    weeks: CalendarWeek[];
}

class CalendarWeek {
    constructor() {
        this.days = [];
    }
    weekNumber: number;
    days: CalendarDay[];
}

class CalendarDay {
    date?: Date;
    exists: boolean;
    hasTime: boolean;
    hasValue: boolean;
    hours: number;
    value: number;
    //entries: TogglTimeEntry[];
    tooltip(): string {
        if (this.hasTime) {
            return `${this.hours.toFixed(2)} hours, £${this.value.toFixed(2)}`;
        }
        return '';
    }
}
